import React from 'react';
import './CourseDetailHeader.css';
import {smartGoBack} from "../../utils/smartNavigate";

interface CourseDetailHeaderProps {
  courseTitle: string;
  progressPercent: number;
  hasActivityToday: boolean;
}

const CourseDetailHeader: React.FC<CourseDetailHeaderProps> = ({
  courseTitle,
  progressPercent,
  hasActivityToday
}) => {

  return (
    <header className="course-detail-header">
      <button className="back-btn" onClick={() => smartGoBack()} aria-label="Go back">
        <img src="/images/arrow-left.png" alt="Back" />
      </button>
      <span className="course-detail-title">{courseTitle}</span>
      <div className="course-detail-progress-indicator">
        <span className="progress-percent">{progressPercent}%</span>
        {hasActivityToday && (
          <div className="activity-marker">
            <span className="checkmark">✓</span>
          </div>
        )}
      </div>
    </header>
  );
};

export default CourseDetailHeader;
